<template>
  <Modal class-name="vertical-center-modal" v-model="show" :mask-closable="false">
    <div slot="header" class="modal-header">水电抄表记录</div>
    <Form :model="formData" :label-width="90"  :rules="formRules" ref="formData">
      <FormItem label="本期示数：" prop="indications" >
        <Input v-model="formData.indications" :number="true"  placeholder="请输入水电示数" style="width: 300px" />
      </FormItem>
    </Form>
    <div slot="footer">
      <div>
        <Button type="text" size="large" @click="close">取消</Button>
        <Button type="primary" size="large" @click="save" :loading="loading" >
          <span v-if="!loading" >保存</span>
          <span v-else>保存中...</span>
        </Button>
      </div>  
    </div>

  </Modal>
</template>

<script type="text/ecmascript-6">
import { waterwattSave } from 'api/workBench'
export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    status:{
      type:Number,
      default:null
    },
    contractFid:{
      type:String,
      default:''
    },
    subContractNum:{
      type:Number,
      default:null
    },
    fid:{
      type:String,
      default:null
    }

  },
  watch:{
    n(val) {
      this.show = true
      this.$refs['formData'].resetFields();
      this.formData.isSynBoolean = false
    }
  },
  data() {
    return {
      loading:false,
      show: false,
      renewalIntention:[],
      formData:{
        isSynBoolean:false,
        isSyn:0,
        indications: ''
      },
      formRules:{
        indications:[{ required: true, type:'number', message:'请输入格式正取的水电示数', trigger:"change" }],
      }
    }
  },
  methods:{
    close(){
      this.show = false
    },
    save() {
    // 调接口
     this.$refs[`formData`].validate(bool => {
       if(bool) {
         if(this.formData.isSynBoolean){
           this.formData.isSyn = 1
         } else {
           this.formData.isSyn = 0
         }

         this.loading = true
         waterwattSave({
           fid: this.fid,
           meterReading: this.formData.indications
         }).then(res => {
            this.loading = false
            this.$Message.success('操作成功！')
            this.show = false
            this.$emit('refresh')
          }).catch( err => {
            this.loading = false
          })

       }
     })
    
    }

  }
}
</script>
